module.exports = __webpack_public_path__ + "img/unable-to-withdraw.23ad99da.svg";